export default "__VITE_ASSET__544a3185__"